import { GatewayLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/outputs/gateway-location.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { LocationListNameCell } from './location-list-name.cell';
import { LocationListNameHeader } from './location-list-name.header';

export const LocationListNameColumn: IdentifiedColumnDef<
  GatewayLocationModel,
  GatewayLocationModel['name']
> = {
  enableSorting: false,
  header: LocationListNameHeader,
  cell: LocationListNameCell,
};
